import scrollTo from './scrollTo'

function scrollToError(selector = '.error') {
  const nodeError = document.querySelector(selector)

  if (nodeError) {
    const rect = nodeError.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const offsetTop = rect.top + scrollTop
    scrollTo(offsetTop)
  }
}

export default scrollToError
